<template>
  <div class="header-expanded-top-section__wrapper">
    <a-header-actions class="header-expanded-top-section__actions">
      <a-notification-icon
        slot="notification-icon"
        slot-scope="{ notificationCount }"
        :is-active="isNotificationsIconActive"
        :notification-count="notificationCount"
        @click.native="onNotificationIconClick"
      />
      <a-user-icon
        slot="user-icon"
        :is-active="isUserIconActive"
        @click.native="onUserIconClick"
      />
      <a-login-button
        slot="sign-in-btn"
        :is-icon-visible="true"
        class="header-expanded-top-section__login-btn"
      />
    </a-header-actions>

    <a-icon
      :icon="$options.consts.ICON.CROSS_IN_CIRCLE"
      :original="true"
      :no-hover="true"
      :width="30"
      :height="30"
      class="header-expanded-top-section__actions-close"
      @click="onCloseMenu"
    />
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import AHeaderActions from '@/components/AHeader/Shared/AHeaderActions/index.vue'
import ANotificationIcon from '@/components/AHeader/Shared/AHeaderActions/ANotificationIconWithModalWidget/ANotificationIcon/index.vue'
import AUserIcon from '@/components/AHeader/Shared/AUserIconWithModalWidget/AUserIcon/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { BUTTON_STYLE } from 'shared/AButton/index.vue'
import ALoginButton from 'shared/ALoginButton'

export default {
  name: 'HeaderExpandedTopSection',
  components: {
    AUserIcon,
    ANotificationIcon,
    AHeaderActions,
    AIcon,
    ALoginButton
  },
  props: {
    isNotificationsIconActive: propValidator([PROP_TYPES.BOOLEAN]),
    isUserIconActive: propValidator([PROP_TYPES.BOOLEAN])
  },
  consts: {
    ICON,
    BUTTON_STYLE
  },
  methods: {
    onCloseMenu() {
      this.$emit('close-menu')
    },
    onNotificationIconClick() {
      this.$emit('notification-icon-click')
    },
    onUserIconClick() {
      this.$emit('user-icon-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-expanded-top-section__wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 18px;
  border-bottom: 1px solid $c--gray-dark;

  .header-expanded-top-section__actions {
    margin-left: 0;

    /deep/ .notification-icon__wrapper {
      .notification-icon__container {
        height: 44px;
        width: 44px;
        background: $c--main;
      }

      &.active .notification-icon__container {
        background: $c--white;

        svg * {
          fill: $c--dark-purple;
        }
      }
    }

    /deep/ .user-icon__wrapper {
      background: $c--main;

      &.active {
        background: $c--white;

        .user-icon__arrow svg * {
          fill: $c--dark-purple;
        }
      }
    }
  }

  .header-expanded-top-section__login-btn {
    width: 111px;
    border-radius: 2px;

    /deep/ .a-button__slot-wrapper {
      align-items: center;
      flex-direction: row;
    }
  }
}
</style>
